export default class DataLayer {
  static doPush(data) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }
}
